import { Fragment } from "react";

const ViewMCQExamQuestion = ({ index, input }) => {
  if (!input) return null;

  return (
    <Fragment>
      <hr className="my-5" />

      {/* QUESTION */}
      <div className="px-4">
        <label className="block font-medium text-sky-700 dark:text-sky-300">
          {index + 1}. {input.question}
        </label>
      </div>

      <hr className="my-5" />

      {/* OPTIONS */}
      {input.options.map((opt, i) => {
        const isUserAnswer = input.answer === opt.id;
        const isCorrect = opt.isAnswer;

        let textColor = "text-slate-700 dark:text-slate-200";
        let badgeText = "";

        if (isCorrect && !isUserAnswer) {
          textColor = "text-green-600";
          badgeText = "Correct Answer";
        }

        if (isCorrect && isUserAnswer) {
          textColor = "text-green-700 font-semibold";
          badgeText = "Right Answer";
        }

        if (!isCorrect && isUserAnswer) {
          textColor = "text-red-600";
          badgeText = "Your Answer";
        }

        return (
          <div
            key={i}
            className={`flex items-center px-4 py-2 rounded-md mb-2 ${textColor}`}
          >
            <input
              type="checkbox"
              disabled
              checked={isUserAnswer}
              className="w-5 h-5 accent-blue-600"
            />

            <span className="ml-3">{opt.option}</span>

            {badgeText && (
              <span className="ml-auto text-base font-medium">
                {badgeText}
              </span>
            )}
          </div>
        );
      })}

      <hr className="my-5" />
    </Fragment>
  );
};

export default ViewMCQExamQuestion;
